module.exports = __webpack_public_path__ + "static/media/background_signup.a29b0efc.jpg";